import React from "react";
import { Link } from "react-router-dom";
import HoverButton from "../../component/HoverButton";
import PageLayout from "../../component/PageLayout";
import IconRightArrow from "../../component/SvgIcons/IconRightArrow";
import IconTallyPrimelogo from "../../component/SvgIcons/IconTallyPrimelogo";
import TallyPrimeNewRelease from "../../component/SvgIcons/TallyPrimeNewRelease";
import { DataFile } from "./DataFile";
import "./style.css";

export default function TellyprimeNow() {
const chunkSize = Math.ceil(DataFile.columns.length / 3);
const part1 = DataFile.columns.slice(0, chunkSize);
const part2 = DataFile.columns.slice(chunkSize, chunkSize * 2);
const part3 = DataFile.columns.slice(chunkSize * 2);

  return (
    <div className="TallyPrimebg newreleaseTally">      
      <PageLayout>
        <div className="filve-release-main">
          <div className="container">
            <div className="filve-release-inner">
              <div className="filve-release-left">             
                <div className="tally-prime-five">                
                  <TallyPrimeNewRelease/>
                </div>
                <ul>
                  <li>Automated Accounting with Bank Statements</li>
                  <li>Integrated Payments and Accounting</li>
                  <li>Smart Bank Reconciliation</li>
                  <li>Connected Banking</li>
                </ul>
                <div className="button d-flex">
              <a
                href="../images/satup/tallyprime_setup6-0.exe"
                download
                className="btn btn-danger"
              >
                <label>
                  Download Now <IconRightArrow />
                </label>
                <span></span>
              </a>
              <HoverButton btnclassname="btn btn-dark" to="/contact">
              <label>
                  Contact Us Now <IconRightArrow />
                </label>
               </HoverButton>            
            </div>
              </div>
              <div className="filve-release">
              <img
                  src="../images/tallyprime/accounting.webp"
                  alt="Tally Partner 5 Star"
                  className="img-fluid"
                />              
              </div>
            </div>
        
          </div>
        </div>
        <div className="container">
          <div className="announce-title text-center">
            <div className="titletwo">
              <h2>
                We're excited to announce the gold launch of{" "}
                <span>TallyPrime Release 6.0.</span>
              </h2>
              <h3>
                It’s now available for download. If you have a valid TSS, you
                can start using it right away.
              </h3>
              <p>
                <strong>TallyPrime Release 6.0</strong> comes with the following
                new features:
              </p>
            </div>
          </div>  
          <section className="peragraf-content">
            <div className="listcontent listcontent1">
              <div className="experience-pic">
                <img
                  src="../images/tellyprime-now/1.svg"
                  alt="Connected GST Experience"
                />
              </div>
              <div className="experience-info">
                <h5>Connected GST Experience</h5>
                <p>
                  Transform your GST upload and filing experience with powerful
                  integration and automation capabilities. Upload GSTR-1 and
                  GSTR-3B data, file GSTR-1, and auto-reconcile GSTR-2A/2B – all
                  without visiting the GST portal. Built-in error detection and
                  correction ensure precise filings, giving you the confidence
                  and accuracy.
                </p>
              </div>
            </div>

            <div className="listcontent listcontent2">
              <div className="experience-pic">
                <img
                  src="../images/tellyprime-now/5.svg"
                  alt="One Click GST Reconciliation"
                />
              </div>
              <div className="experience-info">
                <h5>One Click GST Reconciliation</h5>
                <p>
                  With a single click, TallyPrime automatically downloads and
                  reconciles GSTR-2A/2B, GSTR-1, and GSTR-3B. Get comprehensive
                  summaries of reconciled transactions and mismatches. Quickly
                  reconcile multiple returns, GSTINs, and periods to save time
                  and boost efficiency.
                </p>
              </div>
            </div>

            <div className="listcontent listcontent3">
              <div className="experience-pic">
                <img
                  src="../images/tellyprime-now/2.svg"
                  alt="100% Control on ITC Risks"
                />
              </div>
              <div className="experience-info">
                <h5>100% Control on ITC Risks</h5>
                <p>
                  Safeguard ITC with real-time risk monitoring and proactive
                  management tools. View ITC at risk in the payable report, get
                  precomputed payment suggestions, and keep your ITC status up
                  to date with dynamic reconciliation insights. Reduce potential
                  risks to tax credits and manage your working capital more
                  effectively.
                </p>
              </div>
            </div>
            <div className="listcontent listcontent4">
              <div className="experience-pic">
                <img
                  src="../images/tellyprime-now/3.svg"
                  alt="Automated Ledger Creation"
                />
              </div>
              <div className="experience-info">
                <h5>Automated Ledger Creation</h5>
                <p>
                  Easily create a ledger by fetching party details from the GST
                  portal using just the GSTIN. GSTIN details are retrieved from
                  the portal and populated into the ledger data, saving time and
                  reducing errors. You can create single or bulk ledgers with
                  ease. Additionally, check the party’s GST filing status to
                  assess their compliance health and take appropriate actions.
                </p>
              </div>
            </div>

            <div className="listcontent listcontent5">
              <div className="experience-pic">
                <img
                  src="../images/tellyprime-now/4.svg"
                  alt="Simplified TDS 194Q Compliance"
                />
              </div>
              <div className="experience-info">
                <h5>Simplified TDS 194Q Compliance</h5>
                <p>
                  For businesses with a turnover exceeding INR 10 crore from the
                  previous financial year and payments exceeding 50 lakh for
                  goods in the current year, the latest release helps you
                  efficiently manage TDS deductions for ‘Purchase of Goods’ and
                  ensure regulatory compliance.
                </p>
              </div>
            </div>

            <div className="listcontent" style={{ textAlign: "center" }}>
              <p>
                The latest release is available for TallyPrime, TallyPrime Edit
                Log, TallyPrime Server, TallyPrime Developer, and TallyPrime
                powered by AWS.
              </p>
            </div>
          </section>
        </div>
        <section>
          <div className="container">
            <div className="simplemanagment-Management">
              <div className="titletwo text-center">
                <h2>
                <IconTallyPrimelogo/> <span>Features</span> - List
                </h2>
              </div>
              <div className="simplemanagment d-flex justify-content-between gap-5">
              <div className="simplemanagment-left">
                    {part1.map((section, index) => (
                      <div className="relative" key={index}>
                        <p className={section.highlight ? "yellow-color" : ""}>
                          <strong>{section.title}</strong>
                          {section.isNew && <span className="circalbox"><Link to="#" className="arrow-downNew">New!</Link> </span>}
                        </p>
                        <ul>
                          {section.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>

                  <div className="simplemanagment-left">
                    {part2.map((section, index) => (
                      <div key={index}>
                        <p className={section.highlight ? "yellow-color" : ""}>
                          <strong>{section.title}</strong>
                           {section.isNew && <span className="circalbox"><Link to="#" className="arrow-downNew">New!</Link> </span>}
                        </p>
                        <ul>
                          {section.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>

                  <div className="simplemanagment-left">
                    {part3.map((section, index) => (
                      <div key={index}>
                        <p className={section.highlight ? "yellow-color" : ""}>
                          <strong>{section.title}</strong>
                           {section.isNew && <span className="circalbox"><Link to="#" className="arrow-downNew">New!</Link> </span>}
                        </p>
                        <ul>
                          {section.items.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
              </div>
            </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
